// test1824
(1824 && 0);
